import { gql } from "@apollo/client";
import CHECKOUT_FRAGMENT from "@/fragments/checkout";

const ADD_TO_CART_MUTATION = gql`
	${CHECKOUT_FRAGMENT}
	mutation AddItemToCheckout(
		$retailerId: ID!
		$checkoutId: ID!
		$productId: ID!
		$quantity: Int!
		$option: String!
	) {
		addItem(
			retailerId: $retailerId
			checkoutId: $checkoutId
			productId: $productId
			quantity: $quantity
			option: $option
		) {
			...checkoutFragment
		}
	}
`;
export default ADD_TO_CART_MUTATION;
